import { connect } from 'react-redux';

import { GET_LIST_ROOM_OF_PLACE, GET_PLACE_PRICE_TYPES } from 'store/place/actionTypes';
import {
  CLEAR_PLACE_PROMOTION_DETAIL, CREATE_PLACE_PROMOTION, EDIT_PROMOTION, GET_PLACE_PROMOTION_DETAIL,
  GET_PLACE_PROMOTION_LIST,
} from 'store/promotion/actionTypes';

import CreateRankPromotion from './CreateRankPromotion';

const mapStateToProps = (state) => ({
  isLoadingCreatePromotion: state.Promotion.isLoadingCreatePlacePromotion,
  isLoadingGetPromotionDetail: state.Promotion.isLoadingGetPlacePromotionDetail,
  isLoadingGetPlacePromotionList: state.Promotion.isLoadingGetPlacePromotionList,

  promotionDetail: state.Promotion.placePromotionDetail,
  placePromotionList: state.Promotion.placePromotionList,
  roomOfPlaceList: state.Place.roomOfPlaceList,
  placePriceTypes: state.Place.placePriceTypes,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetListRoomsOfPlace: (payload) => dispatch({
    type: GET_LIST_ROOM_OF_PLACE,
    payload,
  }),

  actionGetPlacePriceTypes: (payload) => {
    dispatch({
      type: GET_PLACE_PRICE_TYPES,
      payload,
    });
  },

  actionCreatePlacePromotion: (payload) => {
    dispatch({
      type: CREATE_PLACE_PROMOTION,
      payload,
    });
  },

  actionGetPromotionDetail: (payload) => {
    dispatch({
      type: GET_PLACE_PROMOTION_DETAIL,
      payload,
    });
  },

  actionEditPromotion: (payload) => {
    dispatch({
      type: EDIT_PROMOTION,
      payload,
    });
  },

  actionGetPlacePromotionList: (payload) => {
    dispatch({
      type: GET_PLACE_PROMOTION_LIST,
      payload,
    });
  },

  actionClearDataPromotionDetail: (payload) => {
    dispatch({
      type: CLEAR_PLACE_PROMOTION_DETAIL,
      payload,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateRankPromotion);
